import React, { useEffect } from 'react';
import { StoreProvider, useStoreContext } from '../../contexts/StoreContext';
import { ThemeProvider } from '../../contexts/ThemeContext';
import { useReferralCapture } from '../../hooks/useReferralCapture';

// StoreProvider resolve o tenant (custom_domain → subdomain → rota legada
// /fornecedor/:supplierSlug). O ThemeProvider consome o tema resolvido.
// useReferralCapture grava ?ref=<userId> no localStorage pra ser usado
// no checkout (share-link tracking).

const REVITER_TITLE = 'Reviter — Sua plataforma de revenda';

function ThemedChildren({ children }) {
  const { theme, store, isStoreSite } = useStoreContext();
  useReferralCapture();

  // Title dinâmico — em whitelabel substitui pelo nome da loja, evitando
  // que "Reviter" apareça na aba do navegador.
  useEffect(() => {
    if (isStoreSite && store?.name) {
      document.title = store.description
        ? `${store.name} — ${store.description.slice(0, 60)}`
        : store.name;
    } else {
      document.title = REVITER_TITLE;
    }
  }, [isStoreSite, store?.name, store?.description]);

  return (
    <ThemeProvider supplierTheme={theme} planType={store?.planType || 'DEFAULT'}>
      {children}
    </ThemeProvider>
  );
}

const AppWrapper = ({ children }) => {
  return (
    <StoreProvider>
      <ThemedChildren>{children}</ThemedChildren>
    </StoreProvider>
  );
};

export default AppWrapper;
